export default "__VITE_ASSET__26e005f3__"